// Same-scheme (https -> https) reachability probe for a server's public
// entry. Mixed-content rules don't apply here — unlike probing the http LAN
// URL from this https page, which IS blocked (see serverLinks.ts and
// decision-web-access-three-networks-2026-08-23 in PreteServer-dev).
//
// `mode: "no-cors"` means the response body/status is opaque and unreadable,
// but that's fine: we only need to know whether the request reached the
// host at all. fetch() rejects on a genuine network failure (DNS, refused
// connection, our own abort-timeout) and resolves on any response,
// including an opaque one — that's a sufficient "reachable" signal.
// `/api/health` is the streamer's existing unauthenticated health route —
// the same one `prism-external-prober` already polls at this hostname
// (see CLAUDE.md "Existing CF workload"). Reused rather than inventing a
// `/healthz` path the streamer doesn't serve; with no-cors the exact path
// barely matters (any completed HTTP response resolves the fetch), but
// hitting a real, already-load-bearing route beats a guess.
export async function probePublicEntry(baseUrl: string, timeoutMs = 2500): Promise<boolean> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    await fetch(`${baseUrl}/api/health`, { mode: "no-cors", signal: controller.signal });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
